import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=83131f10&scoped=true&lang=pug"
import script from "./copy.vue?vue&type=script&lang=coffee"
export * from "./copy.vue?vue&type=script&lang=coffee"
import style0 from "./copy.vue?vue&type=style&index=0&id=83131f10&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83131f10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Wysiwyg: require('/opt/build/repo/site/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default})
